import React from 'react';
import { getEchartTooltipString } from '@/pages/dashboard/components/EchartsTooltip';
import { IColumn } from '@/pages/dashboard/components/EchartsTooltip/type';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';

/**
 * @property {string} nameHeader - 名称标题。
 * @property {string} valueHeader - 值标题。
 * @property {Array<{name: string; value: string; img: string; color: string}>} data - 包含游戏数据项的数组，
 * 每个数据项包括名称、值、图片路径和颜色属性。
 */
interface IGameDataComparisonProps {
  nameHeader: string;
  valueHeader: string;
  data: { name: string; value: string; img: string; color: string; }[];
  dataFormatRule: string;
}

export default (props: IGameDataComparisonProps) => {
  const { nameHeader, valueHeader, data, dataFormatRule } = props;

  const columns: IColumn[] = [
    {
      key: 'name',
      header: nameHeader,
      showIcon: true,
      render: (name, item, column, iconDom) => (
        <div className="dbh-studio-game-data-comparison-tooltip-first">
          <div className="dbh-studio-game-data-comparison-tooltip-dot">
            {iconDom}
          </div>
          <div>
            <img src={item.img} />
          </div>
          <div className="dbh-studio-game-data-comparison-tooltip-first-name">
            {name}
          </div>
        </div>
      ),
    },
    {
      key: 'value',
      header: valueHeader,
      align: 'right',
      render: (value) => (
        <div className="dbh-studio-game-data-comparison-tooltip-sec">
          {dataFormat({ value, formatRule: dataFormatRule })}
        </div>
      ),
    },
  ];

  return (
    <div
      className="dbh-studio-game-data-comparison-tooltip"
      dangerouslySetInnerHTML={{
        __html: getEchartTooltipString({
          table: {
            columns,
            data,
          },
        }),
      }}
    ></div>
  );
};
